var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light-Outline/Arrow - Right"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Arrow - Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M4 11.7257C4 11.346 4.28215 11.0322 4.64823 10.9825L4.75 10.9757H19.75C20.1642 10.9757 20.5 11.3115 20.5 11.7257C20.5 12.1054 20.2178 12.4192 19.8518 12.4689L19.75 12.4757L4.75 12.4757C4.33579 12.4757 4 12.1399 4 11.7257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M13.171 6.23277C12.8775 5.94051 12.8765 5.46563 13.1687 5.17211C13.4344 4.90527 13.851 4.88017 14.1451 5.09739L14.2294 5.16983L20.2794 11.1938C20.547 11.4603 20.5714 11.8784 20.3524 12.1725L20.2794 12.2567L14.2294 18.2817C13.9359 18.574 13.4611 18.573 13.1688 18.2795C12.9031 18.0127 12.8797 17.596 13.0982 17.3028L13.171 17.2189L18.687 11.725L13.171 6.23277Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.339573bb013f78068f3959a99cf7f7b0.svg";
export { ForwardRef as ReactComponent };